import axios from "axios";
import { configs } from "../config";

export const fetchInsights = async (startDate, endDate) => {
  try {
    const response = await axios.get(
      `${configs.cmoverse_url}/sampler/get-insights?start_date=${startDate}&end_date=${endDate}&include_waitlist_details=true`,
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );

    // Process data if needed for waitlisted and blocked domains
    if (
      response.data &&
      response.data.waitlisted_domains &&
      response.data.blocked_domains
    ) {
      // Make sure we have the domains arrays
      response.data.waitlisted_domains.domains =
        response.data.waitlisted_domains.domains || [];
      response.data.blocked_domains.domains =
        response.data.blocked_domains.domains || [];
    }

    return response;
  } catch (error) {
    console.error("Error fetching insights:", error);
    throw error;
  }
};
export const fetchTotalTokens = async (startDate, endDate) => {
  try {
    const response = await axios.get(
      `${configs.cmoverse_url}/sampler/token-sums?start_date=${startDate}&end_date=${endDate}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching total tokens:", error);
    throw error;
  }
};
export const dataCollectionInsights = async (startDate, endDate) => {
  try {
    const response = await axios.get(
      `${configs.cmoweb_url}/api/Dashboard/Dashboard/TotalMentions?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching dataCollection details:", error);
    throw error;
  }
};
export const brandWiseInsights = async () => {
  try {
    const response = await axios.get(
      `${configs.cmoweb_url}/api/Dashboard/Dashboard/BrandWiseDetails`,
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching brandwise details:", error);
    throw error;
  }
};

export const loginToCMO = async (
  username,
  password,
  internal_dashboard_auth = true
) => {
  try {
    const response = await axios.post(`${configs.auth_url}/auth/locobuzz`, {
      username,
      password,
      internal_dashboard_auth,
    });
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

export const fetchWhitelistedDomains = async () => {
  try {
    const response = await axios.post(
      `${configs.auth_url}/auth/get-whitelisted-domains`,
      {},
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching whitelisted domains:", error);
    throw error;
  }
};

export const fetchBlockedDomains = async () => {
  try {
    const response = await axios.post(
      `${configs.auth_url}/auth/get-blocked-domains`,
      {},
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blocked domains:", error);
    throw error;
  }
};

export const deleteWhitelistedDomain = async (domain, p_token) => {
  try {
    const response = await axios.post(
      `${configs.auth_url}/auth/delete-whitelisted-domain`,
      { domain, p_token },
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting whitelisted domain:", error);
    throw error;
  }
};
export const deleteBlockedDomain = async (domain, p_token) => {
  try {
    const response = await axios.post(
      `${configs.auth_url}/auth/delete-blocked-domain`,
      { domain, p_token },
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting blocked domain:", error);
    throw error;
  }
};

export const addBlockedDomain = async (domain, p_token) => {
  try {
    const response = await axios.post(
      `${configs.auth_url}/auth/add-blocked-domain`,
      { domain, p_token },
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding blocked domain:", error);
    throw error;
  }
};

export const addWhitelistedDomain = async (domain, p_token) => {
  try {
    const response = await axios.post(
      `${configs.auth_url}/auth/add-whitelisted-domain`,
      { domain, p_token },
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding whitelisted domain:", error);
    throw error;
  }
};

export const getUsersSignupsTotal = async () => {
  try {
    const response = await axios.get(
      `${configs.cmoverse_url}/sampler/user-signups-total`,
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching total signup users:", error);
    throw error;
  }
};
export const getUsersSignupsInDuration = async (startDate, endDate) => {
  try {
    const response = await axios.get(
      `${configs.cmoverse_url}/sampler/user-signups-by-duration?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching signup users in Duration:", error);
    throw error;
  }
};

export const brandWiseMetrics = async (brandIdsString) => {
  try {
    const response = await axios.get(
      `${configs.cmoweb_url}/api/Dashboard/Dashboard/BrandWiseMetricsFromClickhouse`,
      {
        params: {
          BrandIdsString: brandIdsString,
        },
        headers: {
          "X-API-Key": configs.api_key,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching brandwise details:", error);
    throw error;
  }
};

export const getBrandInsightsAndMetrics = async () => {
  try {
    const insightsResponse = await brandWiseInsights();

    if (
      insightsResponse.data &&
      insightsResponse.data.success &&
      insightsResponse.data.data
    ) {
      const brandData = insightsResponse.data.data;

      const brandIds = brandData.map((brand) => brand.brandId);

      const brandIdsString = brandIds.join(",");

      const metricsResponse = await brandWiseMetrics(brandIdsString);

      return {
        insights: insightsResponse.data,
        metrics: metricsResponse.data,
      };
    } else {
      console.warn(
        "First API call was successful but did not return expected data structure:",
        insightsResponse.data
      );
      throw new Error("Failed to retrieve brand insights data.");
    }
  } catch (error) {
    console.error("Error in fetching brand insights and metrics:", error);
    throw error;
  }
};

export const fetchConversationDetails = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset !== undefined) queryParams.append('offset', params.offset);
    
    const url = `${configs.cmoverse_url}/sampler/conversation-details${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    
    const response = await axios.get(url, {
      headers: {
        "X-API-Key": configs.api_key,
      },
    });
    
    return response;
  } catch (error) {
    console.error("Error fetching conversation details:", error);
    throw error;
  }
};
